module.exports = __webpack_public_path__ + "img/grape@2x.0e4b9b09.png";